module.exports = __webpack_public_path__ + "images/category_lp/watch/omega_samples/sec07_pc_fec9734735510b4cc7d11b910710204a.jpg";